
import { mapActions, mapGetters } from 'vuex';
import { formatPrice } from '@/modules/Helpers';

export default {
    props: {
        item: { type: Object, required: true },
        hideQuantity: { type: Boolean, required: true },
    },
    computed: {
        ...mapGetters(['vat']),
        name() {
            return this.item.name;
        },
        variant() {
            return this.item.variant_text;
        },
        menu() {
            return this.item.menu;
        },
        price() {
            return this.menu ? this.item.price_menu : this.item.price;
        },
        foodOptionGroups() {
            return this.item.food_option_groups;
        },
        uuid() {
            return this.item.uuid;
        },
        quantity() {
            return this.item.quantity;
        },
        linePrice() {
            let price = this.item.price;
            if (this.item.original_price) {
                price = this.item.original_price;
            }
            const extraArr = this.item.food_option_groups.map(group => {
                const optionsExtra = group.food_options.reduce((sum, x) => sum + x.price, 0);
                return optionsExtra;
            });
            const extra = extraArr.reduce((a, b) => a + b, 0);
            price += extra;
            if (price === 0) {
                return 'GRATIS';
            }
            if (this.vat === 'excl') {
                return formatPrice(price * this.quantity * 0.8);
            } else {
                return formatPrice(price * this.quantity);
            }
        },
    },
    methods: {
        ...mapActions('order', ['updateDish']),
        ...mapActions('toast', ['setToast']),
        change(type) {
            const add = type === 'add';
            const quantity = add ? this.quantity + 1 : this.quantity - 1;
            // Trial item logic
            if (this.item.trial_item) {
                if (add) {
                    this.setToast({
                        msg: 'Du kan max tilføje ét test-produkt'
                    });
                    return;
                }
            }
            this.updateDish({ uuid: this.uuid, quantity });
        },
        formatPrice,
        calcPrice (price) {
            if (this.vat === 'excl') {
                return formatPrice(price * this.quantity * 0.8);
            } else {
                return formatPrice(price * this.quantity);
            }
        }
    },
};
